import {createAction} from 'Shared/utilities/actionCreator';
import * as A from 'Users/models/User/Agent/AgentUserType';
import {AgentNumber} from 'Users/models/User/Agent/AgentNumber';
import {
  TaxIdentificationNumberWithNoAgentNumbers,
  ValidTaxIdentificationNumber,
} from 'Users/models/User/Agent/TaxIdentificationNumber';
import {ValidAgentUserType} from 'Users/models/User/Agent/AgentUserType';

export enum AgentUserTypeActionType {
  ADD_AGENCY_ASSOCIATION = 'agentUserType/ADD_AGENCY_ASSOCIATION',
  REMOVE_AGENCY_ASSOCIATION = 'agentUserType/REMOVE_AGENCY_ASSOCIATION',
  CHANGE_TAX_ID = 'agentUserType/CHANGE_TAX_ID',
  CHANGE_IS_ADMINISTRATOR = 'agentUserType/CHANGE_IS_ADMINISTRATOR',
  LOAD_TAX_ID = 'agentUserType/LOAD_TAX_ID',
  ADD_AGENT_NUMBER = 'agentUserType/ADD_AGENT_NUMBER',
  REMOVE_AGENT_NUMBER = 'agentUserType/REMOVE_AGENT_NUMBER',
  LOAD_AGENT_USER_TYPE = 'agentUserType/LOAD_AGENT_USER_TYPE',
}

export const addAgencyAssociation = () => createAction(AgentUserTypeActionType.ADD_AGENCY_ASSOCIATION);
export const removeAgencyAssociation = (index: number) =>
  createAction(AgentUserTypeActionType.REMOVE_AGENCY_ASSOCIATION, {index});
export const loadTaxId = (
  index: number,
  taxId: ValidTaxIdentificationNumber | TaxIdentificationNumberWithNoAgentNumbers
) => createAction(AgentUserTypeActionType.LOAD_TAX_ID, {taxId, index});
export const changeIsAgencyAdministrator = (index: number, isAgencyAdministrator: boolean) =>
  createAction(AgentUserTypeActionType.CHANGE_IS_ADMINISTRATOR, {index, isAgencyAdministrator});
export const changeTaxId = (index: number, taxId: string) =>
  createAction(AgentUserTypeActionType.CHANGE_TAX_ID, {taxId, index});
export const addAgentNumber = (index: number, agentNumber: AgentNumber) =>
  createAction(AgentUserTypeActionType.ADD_AGENT_NUMBER, {agentNumber, index});
export const removeAgentNumber = (index: number, agentNumber: AgentNumber) =>
  createAction(AgentUserTypeActionType.REMOVE_AGENT_NUMBER, {agentNumber, index});
export const loadAgentUserType = (agentUserType: ValidAgentUserType) =>
  createAction(AgentUserTypeActionType.LOAD_AGENT_USER_TYPE, {agentUserType});

type AgentUserTypeState = A.AgentUserType;
const DEFAULT_STATE = A.EmptyAgentUserType;

export type AgentUserTypeAction =
  | ReturnType<typeof changeIsAgencyAdministrator>
  | ReturnType<typeof addAgencyAssociation>
  | ReturnType<typeof loadTaxId>
  | ReturnType<typeof removeAgencyAssociation>
  | ReturnType<typeof changeTaxId>
  | ReturnType<typeof addAgentNumber>
  | ReturnType<typeof loadAgentUserType>
  | ReturnType<typeof removeAgentNumber>;

export default (state: AgentUserTypeState = DEFAULT_STATE, action: AgentUserTypeAction): AgentUserTypeState => {
  switch (action.type) {
    case AgentUserTypeActionType.LOAD_AGENT_USER_TYPE: {
      const {agentUserType} = action.payload;

      return agentUserType;
    }
    case AgentUserTypeActionType.ADD_AGENCY_ASSOCIATION:
      return A.addAgencyAssociation(state);
    case AgentUserTypeActionType.REMOVE_AGENCY_ASSOCIATION: {
      const {index} = action.payload;

      return A.removeAgencyAssociation(index)(state);
    }
    case AgentUserTypeActionType.CHANGE_IS_ADMINISTRATOR: {
      const {index, isAgencyAdministrator} = action.payload;

      return A.changeAgencyAssociationIsAdministratorAccess(index, isAgencyAdministrator)(state);
    }
    case AgentUserTypeActionType.LOAD_TAX_ID: {
      const {taxId, index} = action.payload;

      return A.loadTaxIdNumber(index, taxId)(state);
    }
    case AgentUserTypeActionType.ADD_AGENT_NUMBER: {
      const {agentNumber, index} = action.payload;

      return A.addAgentNumberToAgencyAssociation(index, agentNumber)(state);
    }
    case AgentUserTypeActionType.REMOVE_AGENT_NUMBER: {
      const {agentNumber, index} = action.payload;

      return A.removeAgentNumberFromAgencyAssociation(index, agentNumber)(state);
    }
    case AgentUserTypeActionType.CHANGE_TAX_ID: {
      const {taxId, index} = action.payload;

      return A.changeAgencyAssociationTaxId(index, taxId)(state);
    }
    default:
      return state;
  }
};
